export default "__VITE_ASSET___daylTs8__"